import { api } from "@/client/api"

/**
 * @typedef { Object } ValidateValueResponse
 * @property { boolean } valid
 */

export default {
    validateApplicationData(providerKey, request, fieldIds) {
        return api.post("/validate", {
            providerKey,
            applicationData: request,
            fieldIds,
        })
    },

    /**
     * @param { string } phoneNumber
     * @returns { Promise<ValidateValueResponse> }
     */
    validatePhoneNumber(phoneNumber) {
        return api.post("/validate/phone", {
            phoneNumber,
        })
    },

    /**
     * @param { string } zipCode
     * @param { string } state
     * @returns { Promise<ValidateValueResponse> }
     */
    validateZipCodeState(zipCode, state) {
        return api.post("/validate/zipCode", {
            zipCode: zipCode,
            state: state,
        })
    },

    /**
     * @param { string } email
     * @returns { Promise<ValidateValueResponse> }
     */
    validateEmail(email) {
        return api.post("/validate/email", {
            email,
        })
    },

    validateShortApplicantHash(ssn, dob, lastName) {
        return api.post("/validate/shortApplicantHash", {
            ssn: ssn,
            dob: dob,
            lastName: lastName,
        })
    },
}
